var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('img',{attrs:{"src":"static/img/assets/edit.png"}})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.onClickDelete}},[_vm._v(_vm._s(_vm.$t('deleteStr')))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61f1ada7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Comment/CommentDropDown.vue
// module id = 962
// module chunks = 1